import React from 'react';

function EventImage({ src, className }) {
  return (
    <img 
      src={src} 
      alt="Event flyer" 
      className={className}
      style={{ 
        width: '100%',
        maxWidth: '100%',
        height: 'auto',
        display: 'block',
        margin: '0 auto'
      }} 
    />
  );
}

export default EventImage;
